/* eslint-disable no-undef */
import React, { useState, useContext } from 'react'
import useRWD from '../../hook/useRWD'
import { Navigate, Link, useSearchParams } from 'react-router-dom'
import useLocalStorage from '../../hook/useLocalStorage'
import { Button, Checkbox, Form, Input } from 'antd'
import {
    UserOutlined,
    LockOutlined,
    ApartmentOutlined,
    // FormOutlined,
} from '@ant-design/icons'
import axios from 'axios'
import dayjs from 'dayjs'
import { AuthContext } from '../../store/AuthProvider'
import { SettingContext } from '../../store/SettingProvider'
import bg from '../../images/loginbg.jpg'
import bg_m from '../../images/loginbg_m.jpg'
import logo_w from '../../images/logo_w.svg'
import {
    openNotification,
    systemID,
} from '../../functionTool/functionTool'
import {
    GetEncryptedString,
    GetDecryptedString,
} from '../../functionTool/encryption'

const Login = () => {
    const [loading, setLoading] = useState(false)
    const [name, setName] = useLocalStorage('username', '')
    const [pass, setPass] = useLocalStorage('password', '')
    const [rememberAccout, setRememberAccout] = useLocalStorage(
        'remember',
        true
    )
    const device = useRWD()
    const { AuthUser, user } = useContext(AuthContext)
    const [searchParams] = useSearchParams();
    const { customerSettings } = useContext(SettingContext)

    //客戶設定
    const customerProfileInfo = customerSettings?.[0]?.profileInfo

    //客戶名稱
    const ownerName = customerProfileInfo?.ownerName || '微電能源管理系統'

    //客戶logo url
    const logoUrl = customerProfileInfo?.darkLogoURL || logo_w

    //客戶PC登入背景
    const loginPCBackgroundImage = customerProfileInfo?.loginPCBackgroundImage || bg

    //客戶Mobile登入背景
    const loginMobileBackgroundImage = customerProfileInfo?.loginMobileBackgroundImage || bg_m

    //客戶官網
    const customerOfficialWebsite = customerProfileInfo?.officialWebsite || 'https://www.rfdme.com'

    //客戶聯絡我們
    const customerContactEmail = customerProfileInfo?.contactEmail || 'austin.hung@rfdme.com'

    const getAuth = (systemID, account, password, remember) => {
        // eslint-disable-next-line no-undef
        const res = axios
            .post(`${process.env.REACT_APP_APIGATEWAY_URL}/auth/login`, {
                systemID,
                account,
                password,
            }, { withCredentials: true })
            .then((response) => {
                if (response.data.status === true) {
                    setLoading(false)
                    // 登入成功才記住帳密（避免把打錯的帳密也記起來）
                    if (remember) {
                        setName(GetEncryptedString(account))
                        setPass(GetEncryptedString(password))
                        setRememberAccout(true)
                    } else {
                        setName('')
                        setPass('')
                        setRememberAccout(false)
                    }
                    AuthUser({
                        ...response.data.data,
                    })
                }
                if (response.data.status === false) {
                    setLoading(false)
                    openNotification('top', response.data.msg)
                }
            })
            .catch(() => setLoading(false)) // 網路等錯誤也要解除 loading，避免卡住
        return res
    }

    const onFinish = (values) => {
        setLoading(true)
        const username = values.username.trim()
        const password = values.password.trim()
        // 記住帳密的處理移到 getAuth 成功分支（登入成功才存）
        getAuth(systemID, username, password, values.remember)
    }
    if (user) {
        // 從 URL 獲取重定向參數
        const redirect = searchParams.get('redirect');
        const vppID = searchParams.get('vppID');
        const year = searchParams.get('year');
        const month = searchParams.get('month');

        // 如果有指定頁面，則重定向
        if (redirect) {
            const params = new URLSearchParams();
            if (vppID) params.set('vppID', vppID.toUpperCase());
            if (year) params.set('year', year);
            if (month) params.set('month', month);
            
            const queryString = params.toString();
            return <Navigate to={`/${redirect}${queryString ? `?${queryString}` : ''}`} />
        }
        return <Navigate to="/" />
    }

    return (
        <div
            className="app-login"
            style={
                device !== 'hisesPC' && device !== 'PC'
                    ? { backgroundImage: `url(${loginMobileBackgroundImage})` }
                    : { backgroundImage: `url(${loginPCBackgroundImage})` }
            }
        >
            <div className="app-login-header">
                <div className="container">
                    <div className="app-login-header-menu">
                        <div className="logo">
                            <img src={logoUrl} alt={ownerName} />
                        </div>
                        <div className="menu">
                            <ol>
                                {customerOfficialWebsite && <li>
                                    <Button
                                        type="link"
                                        target="_blank"
                                        href={customerOfficialWebsite}
                                        icon={<ApartmentOutlined />}
                                    >
                                        公司官網
                                    </Button>
                                </li>}
                                {/* <li>
                                    <Button type="link" icon={<UserOutlined />}>
                                        個人訊息
                                    </Button>
                                </li>
                                <li>
                                    <Button type="link" icon={<FormOutlined />}>
                                        註冊新帳號
                                    </Button>
                                </li> */}
                            </ol>
                            <div className="btn">
                                <Button href={`mailto:${customerContactEmail}`} ghost>聯絡我們</Button>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div className="app-login-content">
                <div className="container">
                    <div className="app-login-form">
                        <h1>{ownerName}</h1>
                        {process.env.REACT_APP_STAGE_NAME !== '正式區' && (
                            <div className="stage-name">
                                {process.env.REACT_APP_STAGE_NAME}
                            </div>
                        )}
                        <Form
                            name="login"
                            layout="vertical"
                            onFinish={onFinish}
                            initialValues={{
                                remember: rememberAccout,
                                username: GetDecryptedString(name),
                                password: GetDecryptedString(pass),
                            }}
                            size="large"
                            autoComplete="off"
                            onFieldsChange={(changedFields) => {
                                if (changedFields[0].name[0] === 'remember')
                                    setRememberAccout(changedFields[0].value)
                            }}
                        >
                            <Form.Item
                                name="username"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your Username!',
                                    },
                                ]}
                            >
                                <Input
                                    prefix={
                                        <UserOutlined className="site-form-item-icon" />
                                    }
                                    placeholder="Username"
                                />
                            </Form.Item>

                            <Form.Item
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your Password!',
                                    },
                                ]}
                            >
                                <Input.Password
                                    prefix={
                                        <LockOutlined className="site-form-item-icon" />
                                    }
                                    type="password"
                                    placeholder="Password"
                                />
                            </Form.Item>

                            <Form.Item>
                                <Form.Item
                                    name="remember"
                                    valuePropName="checked"
                                    noStyle
                                >
                                    <Checkbox>記住我</Checkbox>
                                </Form.Item>

                                <Link className="login-form-forgot" to="/forgotpassword">
                                    忘記密碼
                                </Link>
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={loading}
                                    block
                                >
                                    登入
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
            <div className="app-login-footer">
                <div className="container">
                    <p>
                        ©{dayjs().year()} Micro Electricity Co., Ltd. All
                        rights reserved.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Login
